module.exports = __webpack_public_path__ + "img/environment.fd173879.png";